import React from 'react' ;
import ApplicationPageWrapper from "@estar/Components/Common/ApplicationPageWrapper";

const HomePage = () =>
{
    return <ApplicationPageWrapper title='Home'>
        <div>Home Page</div>
    </ApplicationPageWrapper>
}

export default HomePage;